import { Button } from '@/components/Button';
import { twMerge } from 'tailwind-merge';

interface CellContentWithRedirectProps {
  text: string | number;
  /** Disables the redirect button. Defaults to true when the count is 0. */
  disabled?: boolean;
  textWrapperClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  showActionButton?: boolean;
  /** Tooltip shown when hovering the redirect button. */
  actionLabel?: string;
  onClick?: () => void;
}

export const CellContentWithRedirect = ({
  text,
  disabled,
  textWrapperClassName,
  textClassName,
  iconClassName,
  showActionButton = true,
  actionLabel,
  onClick,
}: CellContentWithRedirectProps) => {
  const count = Number(text);
  const isDisabled = disabled ?? (Number.isNaN(count) ? !text : count <= 0);

  return (
    <div className="flex items-center gap-3">
      <div
        className={twMerge('flex flex-1 justify-center', textWrapperClassName)}
      >
        <div
          className={twMerge(
            'text-sm font-semibold px-1.5 py-[2px] rounded-md bg-slate-100 dark-mode:bg-gray-200 dark-mode:text-gray-800 dark-mode:font-medium',
            textClassName,
          )}
        >
          {text ?? 0}
        </div>
      </div>
      {showActionButton && (
        <>
          <div className="font-semibold text-slate-300 dark-mode:text-gray-300">
            |
          </div>
          <div
            title={actionLabel}
            className={twMerge('', isDisabled && 'hover:cursor-not-allowed')}
          >
            <Button
              buttonClassName={twMerge(
                'px-1 h-7 rounded-lg shadow-md',
                isDisabled && 'bg-gray-400',
              )}
              disabled={isDisabled}
              leftIcon={
                <i
                  className={twMerge(
                    'ml-[0.5px] -mt-[1px] ki-outline ki-right-square text-white !text-[16px]',
                    iconClassName,
                  )}
                />
              }
              onClick={onClick}
            />
          </div>
        </>
      )}
    </div>
  );
};
